import { useEffect, useRef } from 'react';
import { Input } from '@/components/ui/input';
import { SearchIcon } from '@/components/layout/icons';

export function SearchBar({
  value,
  onChange,
  onClose,
  matchCount,
}: {
  value: string;
  onChange: (v: string) => void;
  onClose: () => void;
  matchCount: number;
}) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    ref.current?.focus();
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="flex items-center gap-2 border-b border-gray-200 bg-white px-4 py-2">
      <div className="relative flex-1">
        <SearchIcon className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
        <Input
          ref={ref}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Search messages in this thread"
          className="pl-9"
        />
      </div>
      <span className="text-xs text-gray-500">{value ? `${matchCount} matches` : ''}</span>
      <button
        type="button"
        onClick={onClose}
        className="rounded-md px-2 py-1 text-xs text-gray-600 hover:bg-gray-100"
      >
        Close
      </button>
    </div>
  );
}
